import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CoreDirectionsSection from "./components/CoreDirectionsSection";
import NewBooksSection from "./components/NewBooksSection";
import BottomCtaSection from "./components/BottomCtaSection";
import { HomeWebPageJsonLd } from "@/components/feature/JsonLd";

export default function Home() {
  return (
    <div className="bg-background-50">
      <HomeWebPageJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CoreDirectionsSection />
        <NewBooksSection />
        <BottomCtaSection />
      </main>
      <Footer />
    </div>
  );
}